<template>
    <div class="row no-gutters">
        <div class="bill-image col-3">
            <img :src="billIcon" alt="" />
        </div>

        <div class="bill-content col-9" :class="{ 'col-md-5': bill }">
            <div class="bill-name-group">
                <div class="bill-name">{{ bill.name }}</div>
                <div class="bill-provider" v-if="bill">
                    {{ billDescription }}
                </div>
            </div>

            <button
                type="button"
                class="btn-text bill-learn"
                v-if="bill"
                @click="showLearnMore"
            >
                Learn more
            </button>
        </div>

        <div class="bill-footer col-12 col-md-4" v-if="bill">
            <div class="bill-footer-inner">
                <div class="bill-price">
                    <div
                        v-if="bill.prices[0].price_per_housemate === 0"
                        class="price-free"
                    >
                        FREE
                    </div>
                    <div v-else>
                        £{{
                            parseFloat(
                                bill.prices[0].price_per_housemate
                            ).toFixed(2)
                        }}/month
                    <div class="bill-price-sub">per housemate</div>
                    </div>
                </div>
                <!-- select all perks -->
                <input type="hidden" name="bills[]" :value="bill.id">
            </div>
        </div>
    </div>
</template>

<script>
import store from "../../../store";

export default {
    name: "BillCardPerk",

    props: {
        group: {
            type: Object,
            required: true,
        },
        bill: {
            type: Object,
            required: true,
        },
    },

    methods: {
        showLearnMore() {
            store.commit('quote/showBillInfoModal', this.bill.id);
        },
    },

    computed: {
        bill() {
            if (this.$props.bill) {
                return this.$props.bill;
            } else {
                return null;
            }
        },
        billDescription(){
        if (this.bill && this.bill.short_description) {
                return this.bill.short_description;
            } else  {
                return this.bill.description;
            }
        },
        billIcon() {
            if (this.bill && this.bill.provider.logo_path) {
                return this.bill.provider.logo_path;
            } else if (this.$props.group.logo_path) {
                return this.$props.group.logo_path;
            }
        },
    },
};
</script>
